<template>
  <div class="home">
    <div class="portrait flex-row m-b-10" @click="viewPage()">
      <div class="flex-row portraitGroup">
        <img :src="lion" alt="" class="portraitImg">
        <p>{{name}}</p>
      </div>
      <img :src="back" alt="" class="back">
    </div>
    <!-- <tips></tips> -->
    <serves></serves>
    <packages></packages>
    <contents></contents> 
  </div>
</template>
<script>
import back from '@/assets/img/ping.jpg'
import lion from '@/assets/img/lion.jpg'
import tips from '@/components/tips'
import serves from '@/components/serves'
import packages from '@/components/package'

import contents from '@/components/content'
export default {
  components: {
    tips,
    serves,
    contents,
    packages
  },
  name: 'home',
  data(){
    return{
      back,
      lion,
      dataList:{
          customerName:'',
          address: ''
      },
      name:''
    }
  },
  created(){
    this.name = this.$loca.getItem('name')
  },
  methods:{
    viewPage(){
      this.$router.push({path:'/info'})
    },
  }
}
</script>
<style lang="scss" scoped>
  .home{
    background:#f0f0f0;
  }
  .headr{
    height: 96px;
    font-size:32px;
    color: $color-51;
    line-height:96px;
    text-align: center;
  }
  .portrait{
    height: 128px;
    line-height: 128px;
    background: $ffff;
    align-items: center;
    padding: 0 30px;
    justify-content: space-between;
  }
  .portraitImg{
    height: 93px;
    width: 93px;
    border-radius: 50%;
    margin-right: 27px;
  }
  .portraitGroup{
    align-items: center;
  }
  .portraitGroup p {
    line-height: 128px;
    font-size:30px;
    color:$color-51;
  }
  .back{
    width: 20px;
    height: 36px;
  }
</style>
